import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);
  
  useEffect(() => {
    // CRITICAL: Use ref to prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    
    const processAuth = async () => {
      try {
        const hash = window.location.hash;
        const sessionId = new URLSearchParams(hash.substring(1)).get('session_id');
        
        if (!sessionId) {
          navigate('/');
          return;
        }
        
        // Exchange session_id for user data
        const response = await axios.post(`${API}/auth/session`, { session_id: sessionId }, {
          withCredentials: true
        });
        
        const user = response.data;
        
        // Store session token in localStorage for Safari/mobile browsers
        // (Safari blocks third-party cookies, so we use localStorage + Authorization header)
        if (user.session_token) {
          localStorage.setItem('session_token', user.session_token);
        }
        
        // Clear the hash
        window.history.replaceState(null, '', window.location.pathname);
        
        // Redirect based on user role
        if (user.role === 'admin') {
          navigate('/admin', { state: { user }, replace: true });
        } else if (user.role === 'coach') {
          navigate('/coach/dashboard', { state: { user }, replace: true });
        } else {
          // Default for students or undefined roles
          navigate('/', { state: { user }, replace: true });
        }
      } catch (error) {
        console.error('Auth error:', error);
        navigate('/');
      }
    };
    
    processAuth();
  }, [navigate]);
  
  return (
    <div className="min-h-screen flex items-center justify-center bg-deep-dark">
      <div className="text-center">
        <div className="inline-block animate-spin rounded-full h-12 w-12 border-3 border-premium-gold/20 border-t-premium-gold"></div>
        <p className="mt-4 text-white text-lg">Authenticating...</p>
      </div>
    </div>
  );
}

export default AuthCallback;
